import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import { setSettings } from '../redux/currentUser'

export default function * requestChangeUserSettings (action) {
  const settings = action.payload

  const state = yield select()

  const currentSettings = state.kanbo.currentUser.settings

  const newSettings = {
    ...currentSettings,
    ...settings
  }

  const optimisticAction = yield optimisticPut(setSettings(newSettings))

  try {
    yield call(apiAction, 'ChangeProfileSettings', {
      settings: newSettings
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
